import { SAFER_GAMBLING_LINK_DEFINITION, SETTINGS_LINK_DEFINITION } from '../../commonMainNavigationLinkDefinitions.ts';
import type { LinkDefinition, MainNavigationLinksConfig } from '../../mainNavigationLinks.types.ts';
import { ROUTES } from './routes/routes.ts';

const linkDefinitions: Record<string, LinkDefinition> = {
  inbox: {
    href: ROUTES.MY_ACCOUNT.INBOX,
    labelKey: 'inbox',
    trackName: 'Inbox',
    trackContainer: 'Inbox',
    testId: 'my-account-inbox',
    showInboxNotification: true,
  },
  saferGambling: SAFER_GAMBLING_LINK_DEFINITION,
  settings: SETTINGS_LINK_DEFINITION,
};

const links = ['inbox', 'saferGambling', 'settings'] as const;

const MAIN_NAVIGATION_LINKS: MainNavigationLinksConfig = {
  linkDefinitions,
  links,
};

export { MAIN_NAVIGATION_LINKS };
